import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { CodeWindow } from "@/components/shapes/shared/card-visual-parts";
import { asString } from "@/components/shapes/shared/plain-record";
import { cn } from "@/lib/cn";

/** Its last status in the code card's own accent (ok) or warning ink. */
function statusInk(status: string): string {
  if (status === "running") return "text-[color:var(--gadget-code-accent)]";
  if (status === "error") return "text-[color:var(--gadget-code-warn)]";
  return "text-[color:var(--gadget-code-muted)]";
}

/**
 * A terminal (mockup `.term`): its working directory, the `❯ command` with
 * the prompt in the accent, then its last status. No session mounts.
 */
export function TerminalCardPreview({ source, density }: CardPreviewProps) {
  const command = asString(source.command);
  const cwd = asString(source.cwd);
  const status = asString(source.lastStatus);
  return (
    <CodeWindow density={density} data-testid="terminal-card">
      {cwd && (
        <p className="truncate text-[color:var(--gadget-code-muted)]">{cwd}</p>
      )}
      <p className="truncate" data-testid="terminal-card-command">
        <span className="text-[color:var(--gadget-code-accent)]">❯ </span>
        {command}
      </p>
      {status && (
        <p
          className={cn("truncate", statusInk(status))}
          data-testid="terminal-card-status"
        >
          {status}
        </p>
      )}
    </CodeWindow>
  );
}
